module.exports = __webpack_public_path__ + "img/image47.29c12114.png";